@import "open-props/animations.min.css";

.fade-in {
  opacity: 0;
  animation: fade-in .4s var(--ease-elastic-in-3) forwards;
}

.spin, .spin-back {
  animation: spin 0.5s var(--ease-out-3) 1;
}

.spin-back {
  animation-direction: reverse;
}

.slide-up-fade-in {
  opacity: 0;
  animation: fade-in .4s var(--ease-elastic-in-3) forwards,
  slide-in-up .4s var(--ease-elastic-in-3) infinite;
}

.fade-in-grow {
  opacity: 0;
  animation: fade-in .4s var(--ease-elastic-in-3) forwards, grow .4s ease infinite;
}

.fade-out-shrink {
  opacity: 0;
  animation: fade-in .4s var(--ease-elastic-in-3) forwards, grow .4s ease infinite;
  animation-direction: reverse;
}

@keyframes grow {
  from {
    max-height: 0;
  }

  to {
    max-height: var(--size-15);
  }
}
